import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../Auth/utlis/axiosInstance';
import { CircularProgress, Container, Alert, Typography, Button } from '@mui/material';

const PaymentHandler = () => {
    const { contractId } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);    useEffect(() => {
        const initiatePayment = async () => {
            try {
                console.log('Checking payment status for contract:', contractId);
                
                // First check if contract is already paid
                const contractResponse = await api.get(`/customer-contracts/${contractId}`);
                const contract = contractResponse.data;
                
                if (contract && contract.payment_status === 'paid') {
                    setError('This contract has already been paid. No further payment is required.');
                    return;
                }
                
                console.log('Initiating payment for contract:', contractId);                console.log('Creating payment session...');
                const response = await api.get(`/payment/create-session/${contractId}`);
                
                if (response.data.success && response.data.url) {
                    console.log('Payment session created, redirecting to:', response.data.url);
                    // Small delay to ensure logging completes
                    setTimeout(() => {
                        window.location.href = response.data.url;
                    }, 100);
                } else {
                    console.error('Invalid response:', response.data);
                    setError('Failed to create payment session - Invalid response');
                }
            } catch (err) {
                console.error('Payment initiation error:', err);
                let errorMessage;
                
                if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    if (err.response.status === 404) {
                        errorMessage = 'Contract not found. Please check the contract details.';
                    } else if (err.response.status === 400) {
                        errorMessage = err.response.data?.message || 'Invalid payment request.';
                    } else {
                        errorMessage = err.response.data?.message || 'Server error. Please try again.';
                    }
                } else if (err.request) {
                    // The request was made but no response was received
                    errorMessage = 'No response from server. Please check your connection.';
                } else {
                    // Something happened in setting up the request that triggered an Error
                    errorMessage = 'Error setting up payment. Please try again.';
                }
                
                setError(errorMessage);
            } finally {
                setLoading(false);
            }
        };

        if (contractId) {
            initiatePayment();        } else {
            setError('No contract ID provided');
            setLoading(false);
        }
    }, [contractId]);

    if (loading) {
        return (
            <Container sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '80vh' 
            }}>
                <CircularProgress size={40} thickness={4} />
                <Typography sx={{ mt: 2, color: 'text.secondary' }}>
                    Initializing payment session...
                </Typography>
            </Container>
        );
    }

    if (error) {
        return (
            <Container sx={{ mt: 4 }}>
                <Alert 
                    severity="error" 
                    action={
                        <Button color="inherit" size="small" onClick={() => navigate(-1)}>
                            Go Back
                        </Button>
                    }
                >
                    {error}
                </Alert>
            </Container>
        );
    }

    // This will only show briefly before redirect
    return (
        <Container sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '80vh' 
        }}>
            <CircularProgress size={40} thickness={4} />
            <Typography sx={{ mt: 2, color: 'text.secondary' }}>
                Redirecting to payment gateway...
            </Typography>
        </Container>
    );
};

export default PaymentHandler;
